import { render, staticRenderFns } from "./ContextMenuItem.vue?vue&type=template&id=4907c7a5&scoped=true&lang=pug&"
import script from "./ContextMenuItem.vue?vue&type=script&lang=js&"
export * from "./ContextMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenuItem.vue?vue&type=style&index=0&id=4907c7a5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4907c7a5",
  null
  
)

export default component.exports